import { jsx as d } from "react/jsx-runtime";
import { c as a } from "../index-BNmRGtA6.js";
import { c as r } from "../clsx-OuTLNxxd.js";
import '../Card.css';const g = "320px", f = "600px", m = "1025px", h = "_card_wnfky_32", _ = "_primary_wnfky_46", p = "_secondary_wnfky_50", b = "_shouldCenter_wnfky_78", e = {
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  mobile: g,
  "mobile-wide": "480px",
  tablet: f,
  "tablet-wide": "800px",
  desktop: m,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  card: h,
  primary: _,
  secondary: p,
  "padding-s": "_padding-s_wnfky_54",
  "padding-m": "_padding-m_wnfky_58",
  "padding-l": "_padding-l_wnfky_62",
  "borderRadius-s": "_borderRadius-s_wnfky_66",
  "borderRadius-m": "_borderRadius-m_wnfky_70",
  "borderRadius-l": "_borderRadius-l_wnfky_74",
  shouldCenter: b
}, H = a(e.card, {
  variants: {
    variant: {
      primary: e.primary,
      secondary: e.secondary
    }
  },
  defaultVariants: {
    variant: "primary"
  }
}), W = ({
  borderRadius: i = "m",
  children: x,
  className: o,
  height: n,
  padding: t,
  shouldCenter: s,
  variant: c,
  ...y
}) => {
  const l = n ? { "--cxy-card-height": n } : {};
  return /* @__PURE__ */ d(
    "div",
    {
      className: r(
        H({ variant: c }),
        {
          [e[`padding-${t}`]]: t && typeof t == "string",
          [e.shouldCenter]: s,
          [e[`borderRadius-${i}`]]: i
        },
        o
      ),
      "data-cxy-name": "card",
      style: l,
      ...y,
      children: x
    }
  );
};
export {
  W as Card
};
